import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Clock } from 'lucide-react';
export function MonthlyPopup() {
  const upcomingPopups = [{
    label: 'August 20',
    vendor: 'Que with a View',
    cuisine: 'Backyard BBQ & Smoking • Chef D\u2019Mac',
    date: 'Thu August 20 • 6–8 PM',
    image: 'https://cdn.magicpatterns.com/uploads/dECfq9ctxbik8VPPub9NHn/Que_with_a_view.png'
  }];
  return <section id="popups" className="py-20 lg:py-32 bg-foodCream" data-id="element-128" data-mp="1gm4p6hih95k6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129" data-mp="1lkfy8q0y7c1c">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-130" data-mp="1qc7p71o0njs0">
          <h2 className="text-5xl md:text-6xl font-extrabold uppercase mb-4" data-id="element-131" data-mp="208aswbyinqh2">
            August <span className="text-foodTomato" data-id="element-132" data-mp="24cimamfx5ulm">Resident Chef</span>
          </h2>
          <p className="text-xl max-w-2xl font-medium" data-id="element-133" data-mp="1b4bhqwfxjjkc">
            Each month a new resident chef takes over the Pavilion kitchen. This
            August, we're thrilled to welcome Chef D'Mac of D'Mac's BBQ.
          </p>
        </motion.div>

        {/* Featured This Month */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-foodCard border-4 border-foodMaroon shadow-[8px_8px_0px_0px_#3D1610] overflow-hidden mb-16 flex flex-col lg:flex-row" data-id="element-134" data-mp="w72nnuz8s1ox">
          <div className="lg:w-2/5 relative bg-foodGold flex items-center justify-center border-b-4 lg:border-b-0 lg:border-r-4 border-foodMaroon overflow-hidden" data-id="element-135" data-mp="1f5onz7mxpors">
            <img src="https://cdn.magicpatterns.com/uploads/4ovMyvqRGNoCYgtycJ11L4/IMG_2456.jpg" alt="Chef D'Mac" className="w-full h-full object-cover mix-blend-multiply" data-id="element-136" data-mp="2cmly0fx2b861" />
          </div>
          <div className="lg:w-3/5 p-8 lg:p-12 flex flex-col justify-center" data-id="element-137" data-mp="avmw6a40vlxs">
            <div className="inline-flex w-fit items-center gap-2 bg-foodTomato text-white text-sm font-bold px-3 py-1 mb-4 border-2 border-foodMaroon rotate-[-2deg]" data-id="element-138" data-mp="3sc4rvmzhh3tb">
              RESIDENT CHEF • AUGUST 2026
            </div>
            <h3 className="text-4xl font-extrabold uppercase mb-2" data-id="element-139" data-mp="3ja3wkvnt8rua">
              Meet Chef D'Mac
            </h3>
            <p className="font-display text-xl text-foodMaroon/70 mb-6" data-id="element-140" data-mp="3ndjqhk8hwe3a">
              D'Mac's BBQ • Smoked Meats & Specialty Eats
            </p>
            <p className="mb-4 text-lg" data-id="element-141" data-mp="3ec2fuhdux4lz">
              D Mac’s BBQ is setting up shop at The Food Pavilion for a whole month of smoked to perfection meats and specialty eats, straight from a pitmaster with serious backyard to business grit behind him.
            </p>
            <p className="mb-4 text-lg" data-id="element-142" data-mp="1cjxq9cjtyjef">
              It all started over two decades ago, when D Mac was just firing up the smoker for family and friends in his backyard, with his father cheering him on every step of the way. Word got around fast, neighbors couldn't get enough, and after years of trial, error, and dialing in that perfect savory profile, D Mac's BBQ became the real deal. His father never stopped believing in him, always pushing him to take it seriously and turn it into something real. Now, that same passion and hard earned craft is coming to The Food Pavilion, dishing out quality smoked meats and specialty items guided by a simple philosophy: Food of Love. Love of Food.
            </p>
            <p className="mb-6 text-lg" data-id="element-143" data-mp="3ppcfzek2gvu0">
              Stop by and taste the flavor that took over twenty years to perfect. Whether you're a longtime fan or trying D Mac's for the first time, this pop up is your chance to experience real, honest barbecue, made with the same love that started it all. D Mac's BBQ is dedicated to his father, his biggest supporter from day one. Come hungry. Come often. This one's worth the visit.
            </p>
            <p className="mb-6 text-lg font-bold text-foodOrange" data-id="element-144" data-mp="mfo53h90coy0">
              <a href="https://instagram.com/eatwithdmac" target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-145" data-mp="rfkb1m19mqg7">@eatwithdmac on IG</a>
            </p>

            <div className="space-y-3 mb-8" data-id="element-146" data-mp="vgclgilvj1e2">
              <div className="flex items-center gap-2 text-foodMaroon font-bold" data-id="element-147" data-mp="3uwizs9fnj310">
                <Clock size={20} className="text-foodOrange shrink-0" data-id="element-148" data-mp="3pzeg0c6vuog" />
                <span data-id="element-149" data-mp="3q7qxr4egxz4">Saturday & Sunday • 11 AM – 3 PM</span>
              </div>
              <div className="flex items-center gap-2 text-foodMaroon font-bold" data-id="element-150" data-mp="7qrq108jabnw">
                <Calendar size={20} className="text-foodOrange shrink-0" data-id="element-151" data-mp="cijl9o2mx5kd" />
                <span data-id="element-152" data-mp="3c617g5yqe9g6">All August long</span>
              </div>
              <div className="flex items-start gap-2 text-foodMaroon/80 font-medium" data-id="element-153" data-mp="3c5j6wx51d92g">
                <MapPin size={20} className="shrink-0 mt-0.5 text-foodOrange" data-id="element-154" data-mp="3g5tluzat39tg" />
                <span data-id="element-155" data-mp="38msm8p34m0bd">
                  The Food Pavilion, India Basin Waterfront Park • 900 Innes
                  Ave, San Francisco, CA
                </span>
              </div>
            </div>

            <a href="https://drive.google.com/file/d/1xhvomwD0XEo5CbJPBWqIqmD5ysZezK_8/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-block bg-foodTomato text-white font-bold text-lg py-4 px-8 border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#3D1610] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0px_0px_#3D1610] transition-all w-full sm:w-auto text-center" data-id="element-156" data-mp="2zluj090ihwtu">
              Check Out the Menu
            </a>
          </div>
        </motion.div>

        {/* More This Month */}
        <div data-id="element-157" data-mp="26x6tu2cn6nb0">
          <h3 className="text-3xl font-extrabold uppercase mb-8 flex items-center gap-4" data-id="element-158" data-mp="26xqbdhydr9oi">
            Upcoming Community Experiences
            <div className="h-1 flex-grow bg-foodMaroon/10" data-id="element-159" data-mp="1sbt025vebryd"></div>
          </h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-160" data-mp="1sdvz1fej0vf8">
            {upcomingPopups.map((popup, idx) => <motion.a key={idx} href={popup.link || undefined} target={popup.link ? '_blank' : undefined} rel={popup.link ? 'noopener noreferrer' : undefined} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="block bg-foodCard border-4 border-foodMaroon group cursor-pointer hover:-translate-y-2 transition-transform duration-300" data-id="element-161" data-mp="1x8jekorjyfho" data-mpi={idx}>
                <div className="h-56 relative border-b-4 border-foodMaroon overflow-hidden bg-foodMaroon" data-id="element-162" data-mp="2ysn660u8tchp">
                  <img src={popup.image} alt={popup.vendor} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" data-id="element-163" data-mp="nbbi7ydqpp17" />
                  <div className="absolute top-0 right-0 bg-foodMaroon text-foodCream font-bold px-4 py-2" data-id="element-164" data-mp="s3mm1cblpuz1">
                    {popup.label}
                  </div>
                </div>
                <div className="p-6" data-id="element-165" data-mp="4fv51vf48trf">
                  <p className="text-foodOrange font-bold text-sm mb-1" data-id="element-166" data-mp="3vl4rjd3wipwa">
                    {popup.date}
                  </p>
                  <h4 className="text-2xl font-extrabold uppercase mb-1" data-id="element-167" data-mp="dg9th3ndmoz5">
                    {popup.vendor}
                  </h4>
                  <p className="text-foodMaroon/70 font-medium" data-id="element-168" data-mp="9fhgq0faq1y4">
                    {popup.cuisine}
                  </p>
                </div>
              </motion.a>)}
          </div>
        </div>
      </div>
    </section>;
}